<template>
  <div class="newsFeed">
    <div class="index-header">
      <span class="title">
        <svg-icon icon-class="newsFeed" class="iconstyle"></svg-icon>最新动态
      </span>
      <span class="other more" @click="jumpMore">
        更多
        <i class="el-icon-d-arrow-right"></i>
      </span>
    </div>
    <div class="container">
      <div class="news" v-if="dataFeed">
        <li v-for="(item,index) in dataFeed" :key="index" @click="toDetail(item)">
          <span class="title ub-f1">
            <!-- <svg-icon icon-class="warn1" class="iconstyle"></svg-icon> -->
            {{item.MianTitle.substring(0,9)}}
          </span>
          <span class="time">{{item.PubTime|formatDate('yyyy-MM-dd')}}</span>
        </li>
      </div>
      <div class="Img" v-if="showNoMessageImg">
        <img src="@/components/indexnew/img/noMessage.png" />
      </div>
    </div>
  </div>
</template>

<script>
import { ArticleControllerSvr } from "@/service/ArticleControllerSvr.js";
import { ArticleQueryPara } from "@/models/queryparams/ArticleQueryPara.js";
import { mapState } from "vuex";
export default {
  components: {},
  props: {},
  data() {
    return {
      ArticleQueryPara: new ArticleQueryPara(),
      dataFeed: [],
      showNoMessageImg: true
    };
  },
  computed: { ...mapState(["token"]) },
  created() {
    this.ArticleControllerSvr = new ArticleControllerSvr();
  },
  mounted() {
    this.getdate();
  },
  methods: {
    jumpMore() {
      this.$router.push({ path: "newsFeedMore" });
    },
    getdate() {
      //1 通知公告
      //2 最新动态
      this.ArticleQueryPara.setParamByCategoryCode("001002");
      const myworkLoading = this.$loading({
        target: document.querySelector(".news")
      });
      this.ArticleControllerSvr.GetArticleList(
        this.token,
        this.ArticleQueryPara,
        0,
        5,
        true,
        true,
        true
      )
        .then(res => {
          this.dataFeed = res._Items;
          this.showNoMessageImg = false;
          myworkLoading.close();
        })
        .catch(err => {
          myworkLoading.close();
          this.$message({
            type: "error",
            message: err.Msg
          });
        });
    },
    toDetail(item) {
      this.$router.push({
        path: "newsFeed",
        query: {
          item: JSON.stringify(item)
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "./css/common.scss";
.newsFeed {
  background: #fff;
  .iconstyle {
    font-size: 18px;
    margin: 0 6px;
    color: #ff4546;
  }
  .container {
    height: 125px;
    padding: 10px 0;
    overflow: hidden;
    .Img {
      padding: 5px 12px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .news {
      li {
        padding: 5px 12px;
        display: flex;
        justify-content: space-between;
        height: 35px;
        box-sizing: border-box;
        line-height: 25px;
        cursor: pointer;
        .title {
          position: relative;
          width: 163px;
          height: 35px;
          font-family: MicrosoftYaHei;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 35px;
          //color: #333333;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .time {
          font-size: 14px;
          line-height: 30px;
          //color: #666;
        }
        &:nth-child(2n) {
          background: #f7f8fa;
        }
        &:hover {
          background: #e3f0ff;
        }
      }
    }
  }
}
</style>